import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getPageContentAbout } from '../../../../entities/PageContent'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './AboutSection.module.scss'

const AboutSection: React.FC = () => {
    const { t, i18n } = useTranslation()
    const about = useSelector(getPageContentAbout)
    const lang = i18n.language.split('-')[0]

    const isRu = lang === 'ru'

    const title = about
        ? isRu
            ? about.titleRu
            : about.titleEn
        : t('about.title')
    const text = about ? (isRu ? about.textRu : about.textEn) : t('about.text')
    const priceAmount = about?.priceAmount ?? '$90'
    const minDaysValue = about?.minDaysValue ?? '3+'
    const mileageValue = about?.mileageValue ?? '∞'
    const perDayLabel = about
        ? isRu
            ? about.perDayLabelRu
            : about.perDayLabelEn
        : t('about.perDay')
    const minDaysLabel = about
        ? isRu
            ? about.minDaysLabelRu
            : about.minDaysLabelEn
        : t('about.minDays')
    const mileageLabel = about
        ? isRu
            ? about.mileageLabelRu
            : about.mileageLabelEn
        : t('about.mileage')

    return (
        <PageSection
            title={title}
            style={{ backgroundColor: 'var(--bg-muted)' }}
        >
            <div className={cls.wrap}>
                <p className={cls.lead}>{text}</p>
                <div className={cls.statRow}>
                    <div className={cls.stat}>
                        <span className={cls.statNum}>{priceAmount}</span>
                        <span className={cls.statLabel}>{perDayLabel}</span>
                    </div>
                    <div className={cls.stat}>
                        <span className={cls.statNum}>{minDaysValue}</span>
                        <span className={cls.statLabel}>{minDaysLabel}</span>
                    </div>
                    <div className={cls.stat}>
                        <span className={cls.statNum}>{mileageValue}</span>
                        <span className={cls.statLabel}>{mileageLabel}</span>
                    </div>
                </div>
            </div>
        </PageSection>
    )
}

export default AboutSection
